import { Col, Divider, Modal, notification, Row } from 'antd';
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import orderAPI from '~/api/OrderAPI';
import { IMAGES } from '~/assets/assetsPath';
import { getNumberWithCommas } from '~/utils';
import CancelModal from '../FormCancel';
import DoubleModal from '../FormDouble';
import styles from './ItemOrder.module.scss';

const cx = classNames.bind(styles);

const Item = styled.div`
    .ant-divider-horizontal {
        margin: 14px 0px;
    }
`;

const ItemOrder = ({ item, handleGetListHistoryOrder, page, activeKey }) => {
    const navigate = useNavigate();

    const [isShowCancelOrderModal, setIsShowCancelOrderModal] = useState(false);
    const handleShowCancelOrderModal = () => {
        setIsShowCancelOrderModal(true);
    };
    const onRejectCancelOrder = () => {
        setIsShowCancelOrderModal(false);
    };
    const onAgreeCancelOrder = async () => {
        try {
            await orderAPI.cancelOrderAPI(item?.id);
            notification.open({
                message: 'Order canceled successfully',
                duration: 2,
                placement: 'top',
            });
            await handleGetListHistoryOrder(page, activeKey);
            await setIsShowCancelOrderModal(false);
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    const [isShowCompleteOrder, setIsShowCompleteOrder] = useState(false);
    // const handleShowCompleteOrder = () => {
    //     setIsShowCompleteOrder(true);
    // };
    const onRejectCompleteOrder = () => {
        setIsShowCompleteOrder(false);
    };
    const onAgreeCompleteOrder = async () => {
        try {
            await orderAPI.receiveOrderAPI(item?.id);
            notification.open({
                message: 'Received goods successfully',
                duration: 2,
                placement: 'top',
            });
            await handleGetListHistoryOrder(page, activeKey);
            await setIsShowCompleteOrder(false);
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    const [isShowDoubleOrderModal, setIsShowDoubleOrderModal] = useState(false);

    const handleShowDoubleOrderModal = (data) => {
        if (data?.order_online) {
            setIsShowDoubleOrderModal(true);
        } else {
            notification.open({
                message: 'You cannot redeem this order!',
                duration: 2,
                placement: 'top',
            });
        }
    };
    const onRejectDoubleOrder = () => {
        setIsShowDoubleOrderModal(false);
    };
    const onAgreeDoubleOrder = () => {
        if (item?.order_type === 'PRODUCT') {
            navigate(`/dat-hang-lai/${item?.id}`);
        } else {
            navigate(`/dat-goi-dich-vu-lai/${item?.id}`);
        }
        setIsShowDoubleOrderModal(false);
    };

    const handleNavigateDetail = (data, type) => {
        if (type === 'PRODUCT') {
            navigate(`/thong-tin-san-pham/${data?.product?.id}`);
        }
        if (type === 'COMBO') {
            navigate(`/goi-dich-vu-chi-tiet/${data?.combo_service_id}`);
        }
    };

    return (
        <Item>
            <div className={cx('container')}>
                <Row align="middle">
                    <Col xs={12}>
                        <Row align="middle">
                            Order code: <span className={cx('code_service')}>#{item?.order_code}</span>
                        </Row>
                        <Row align="middle" style={{ marginTop: '5px' }}>
                            Order type:
                            <span className={cx('order_type')}>
                                {item?.order_type === 'PRODUCT' ? 'Product' : 'Service package'}
                            </span>
                        </Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end" className={cx('status')}>
                            {item?.activity === 'WAITING' && <span>Waiting for confirmation</span>}
                            {item?.activity === 'CONFIRMED' && <span>Waiting for delivery</span>}
                            {item?.activity === 'PROCESSING' && <span>Delivering</span>}
                            {item?.activity === 'COMPLETED' && <span>Received</span>}
                            {item?.activity === 'CANCELED' && <span>Canceled</span>}
                        </Row>
                    </Col>
                </Row>

                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                {item?.order_items?.length
                    ? item?.order_items?.map((product, index) => {
                        return (
                            <>
                                <Row
                                    className={cx('service')}
                                    key={index}
                                    onClick={() => handleNavigateDetail(product, item?.order_type)}
                                >
                                    <Col xs={6} xl={5}>
                                        <Row className={cx('image')}>
                                            <img
                                                src={
                                                    product?.thumbnail || product?.image[0] || IMAGES.ImagePlaceholder
                                                }
                                                alt=""
                                            />
                                        </Row>
                                    </Col>
                                    <Col xs={18} xl={19} className={cx('content')}>
                                        <div>
                                            <Row className={cx('name')}>{product?.title}</Row>
                                            <Row className={cx('type')}>
                                                <span>{product?.product?.category?.title}</span>
                                            </Row>
                                            <Row align="middle">
                                                <Col xs={2}>
                                                    <Row className={cx('type')}>x{product?.quantity}</Row>
                                                </Col>
                                                <Col xs={22}>
                                                    <Row className={cx('right_content')}>
                                                        {parseInt(product?.discount_price) ||
                                                            product?.product?.price !== product?.price ? (
                                                            <div className={cx('old_price')}>
                                                                <del>
                                                                    {getNumberWithCommas(
                                                                        product?.product?.price || product?.price,
                                                                    )}
                                                                    d
                                                                </del>
                                                            </div>
                                                        ) : null}
                                                        <div className={cx('new_price')}>
                                                            {getNumberWithCommas(
                                                                product?.price - parseInt(product?.discount_price),
                                                            )}
                                                            d
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                            </>
                        );
                    })
                    : null}
                {Number(item?.discount) ? (
                    <Row className={cx('total_price')}>
                        <Col xs={12}>
                            <Row className={cx('title')}>Reduced:</Row>
                        </Col>
                        <Col xs={12}>
                            <Row justify="end" className={cx('price')}>
                                - {getNumberWithCommas(item?.discount)} d
                            </Row>
                        </Col>
                    </Row>
                ) : null}

                <Row className={cx('total_price')}>
                    <Col xs={12}>
                        <Row className={cx('title')}>Total amount:</Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end" className={cx('price')}>
                            {getNumberWithCommas(item?.total_cost)} d
                        </Row>
                    </Col>
                </Row>
                {item?.branch ? (
                    <Row className={cx('payment_type')}>
                        <span>{item?.branch?.name}</span>
                    </Row>
                ) : null}

                <Row className={cx('payment_type')}>
                    {item?.payment_type === 'CASH' && <span>Cash payment</span>}
                    {item?.payment_type === 'CARD' && <span>Card payment</span>}
                    {/* {item?.payment_type === 'WALLET' && <span>Payment with service limit wallet</span>} */}
                    {item?.payment_type === 'TRANSFER' && <span>Payment by transfer</span>}
                </Row>
                <Row className={cx('footer')} align="middle">
                    <Col xs={8}>
                        <Row className={cx('noti')}>
                            {(item?.activity === 'WAITING' || item?.activity === 'CONFIRMED') && (
                                <>Please check the information before Beauty-ms delivers!</>
                            )}
                            {/* {item?.activity === 'PROCESSING' && (
                                <>Received the goods? If so, please select "Received goods"!</>
                            )} */}
                            {item?.activity === 'COMPLETED' && <>Is the product good? If so, please select "Buy again"!</>}
                            {item?.activity === 'CANCELED' && <>Order canceled, you can choose "Buy again"!</>}
                        </Row>
                    </Col>
                    <Col xs={16}>
                        <Row justify="end">
                            <div className={cx('btn', 'detail')} onClick={() => navigate(`/don-hang/${item?.id}`)}>
                                Detail
                            </div>
                            {/* {(item?.activity === 'WAITING' || item?.activity === 'CONFIRMED') && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCancelOrderModal}>
                                    Cancel order
                                </div>
                            )} */}
                            {/* {item?.activity === 'PROCESSING' && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCompleteOrder}>
                                    Has received the goods
                                </div>
                            )} */}
                            {/* {item?.activity === 'WAITING' && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCancelOrderModal}>
                                    Cancel order
                                </div>
                            )} */}
                            {(item?.activity === 'WAITING' || item?.activity === 'CONFIRMED') && (
                                <div className={cx('btn', 'cancel')} onClick={handleShowCancelOrderModal}>
                                    Cancel order
                                </div>
                            )}
                            {(item?.activity === 'COMPLETED' || item?.activity === 'CANCELED') &&
                                item?.order_online && (
                                    <div
                                        className={cx('btn', 'cancel')}
                                        onClick={() => handleShowDoubleOrderModal(item)}
                                    >
                                        Repurchase
                                    </div>
                                )}
                        </Row>
                    </Col>
                </Row>
            </div>
            <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />

            {isShowCancelOrderModal && (
                <Modal
                    centered
                    visible={isShowCancelOrderModal}
                    onCancel={() => setIsShowCancelOrderModal(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeCancelOrder}
                            onRejectCancel={onRejectCancelOrder}
                            text="Do you want to cancel this order?"
                        />
                    </div>
                </Modal>
            )}

            {isShowCompleteOrder && (
                <Modal
                    centered
                    visible={isShowCompleteOrder}
                    onCancel={() => setIsShowCompleteOrder(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeCompleteOrder}
                            onRejectCancel={onRejectCompleteOrder}
                            text="Have you received this order?"
                        />
                    </div>
                </Modal>
            )}

            {isShowDoubleOrderModal && (
                <Modal
                    centered
                    visible={isShowDoubleOrderModal}
                    onCancel={() => setIsShowDoubleOrderModal(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <DoubleModal
                            onAgreeDouble={onAgreeDoubleOrder}
                            onRejectDouble={onRejectDoubleOrder}
                            text="Do you want to reset this order?"
                        />
                    </div>
                </Modal>
            )}
        </Item>
    );
};

export default ItemOrder;
